module.exports = __webpack_public_path__ + "img/lk.49489024.png";